import { RealtyObjectType } from '@search/filter-enums/enums/RealtyObjectType';
import { ISearchType } from '@search/offer-search-routes/src';

export function offerSearchSeoIconCategory({
    categoryType
}: {
    categoryType: ISearchType['categoryType'];
}) {
    switch (categoryType) {
        case RealtyObjectType.LAND:
            return '🌱';
        case RealtyObjectType.HOUSE:
            return '🏡';
        case RealtyObjectType.ROOM:
        case RealtyObjectType.FLAT:
        default:
            return '🏢';
    }
}
